// extracted by mini-css-extract-plugin
export default {"container":"DurationFilter_container__d68Nw","suffix":"DurationFilter_suffix__W2lur"};